export class JobProgressStepRestoreVolumeData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceVolumeId",
            "baseName": "sourceVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "deviceName",
            "baseName": "deviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepRestoreVolumeData.attributeTypeMap;
    }
    constructor() {
    }
}
